module.exports = __webpack_public_path__ + "8a307fb61e3d567420cf35a019676bc1.svg";